export default "__VITE_ASSET__BkbgxiZb__"